import { render, staticRenderFns } from "./BoxTwo.vue?vue&type=template&id=4bcc7886&scoped=true"
import script from "./BoxTwo.vue?vue&type=script&lang=js"
export * from "./BoxTwo.vue?vue&type=script&lang=js"
import style0 from "./BoxTwo.vue?vue&type=style&index=0&id=4bcc7886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc7886",
  null
  
)

export default component.exports